import { Typography } from "@mui/material";
import { useContext } from "react";
import DialogAnimate from "src/components/animate/DialogAnimate";

import Context from "../context";
import DemoTable from "./DetailTable/DemoTable";

export default function DemoDetailDialog() {
	const { state, actions } = useContext(Context);

	return (
		<DialogAnimate maxWidth={"sm"} onClose={actions.hideDemoDialog} open={state.showDemoDialog}>
			<Typography variant='subtitle1' sx={{ p: 3, pb: 2 }}>
				{state.email}
			</Typography>
			<DemoTable email={state.email} />
		</DialogAnimate>
	);
}
